import {FormService, HistoryService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        history: [],
    },
    mutations: {
        saveHistory(current, history) {
            current.history.splice(0);
            current.history = history;
        }
    },
    actions: {
        async getHistoryAction({commit}) {
            await bindLoading(commit, async () => commit('saveHistory'
                , await HistoryService.getFormsHistory()), 'history')
        },
        async cancelFormAction({ commit, state}, id){
            return await bindLoading(commit, async () => {
                const {success, messages, instance} = await FormService.cancel(id);
                if(success){
                    const newHistory = state.history.filter(h => h.id !== instance)
                        .concat(state.history.filter(h => h.id === instance).map((h => ({
                            ...h,
                            cancelable: false,
                            status: '已取消'
                        }))));

                    commit('saveHistory', newHistory);
                }
                return {success, messages};
            }, 'history')
        }
    }
}